import { configureStore } from "@reduxjs/toolkit";
import colorsSlice from "./slices/colorsSlice";
import gradientOrColourSlice from "./slices/gradientOrColour";
import mainColoursSlice from "./slices/mainColoursSlice";
// import themesSlice from "./slices/themesSlice";
import stepSlice from "./slices/stepSlice";
import generatedThemesSlice from "./slices/generatedThemesSlice";
import manualColorSlice from "./slices/manualColoursSlice";
import selectedColourSlice from "./slices/selectedColourSlice";
import sortingSlice from "./slices/sortingSlice";
import brandColourSlice from "./slices/brandColoursSlice";
import  darkLightSlice  from "./slices/darkLightThemeSlice";
import accentsSlice from "./slices/accentsSlice";

export const store = configureStore({
  reducer: {
    color: colorsSlice,
    step: stepSlice,
    accents: accentsSlice,
    sorting: sortingSlice,
    brandColors: brandColourSlice,
    manualColors: manualColorSlice,
    selectedColour: selectedColourSlice,
    // theme: themesSlice,
    gradientOrColour: gradientOrColourSlice,
    mainColours: mainColoursSlice,
    generatedThemes: generatedThemesSlice,
    darkLight: darkLightSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
